<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-list" :style="list_Style">
      <div :ref="'dftItem'+index" class="dft-item" v-for="(item,index) in couponList" :key="index" :style="list_item_Style(item.isUse)">
        <div v-if="['0','1','2','3','4','5','8'].includes(couponClass)" class="dft-coupon_description" :style="coupon_description_Style(item)">
          <span v-if="['0'].includes(couponClass)" class="dft-coupon_dot_0_l"></span>
          <span v-if="['1','2'].includes(couponClass)" class="dft-coupon_bg-l" :style="coupon_bg_l_Style(item.isUse)"></span>
          <span v-if="['1','2'].includes(couponClass)" class="dft-coupon_bg" :style="coupon_bg_Style(item.isUse)"></span>
          <div v-if="[0].includes(listClass)" class="dft-coupon_left" :style="coupon_left_Style(item)">
            <div class="dft-coupon_type" :style="coupon_type_Style(item)">
              {{ getCouponType(item.couponType) }}
              <span class="dft-coupon_unit-sp"></span>
            </div>
            <div class="dft-coupon_info" :style="coupon_info_Style(item)">
              <div class="dft-coupon_info-up">{{ item.couponName }}</div>
              <div class="dft-coupon_info-down">
                {{ item.couponName }}
              </div>
            </div>
          </div>
          <div v-if="[1,2,3].includes(listClass)" class="dft-coupon_left" :style="coupon_left_Style(item)">
            <div class="typeitem" v-if="item.couponType == 1">
              <div class="dft-coupon_info-left">
                <div class="price-tag">¥</div>
                <div class="ellipsis-text price-sale-price">{{ item.faceAmount }}</div>
              </div>
              <div class="dft-coupon_info" :style="coupon_info_Style(item)">
                <div class="ellipsis-text dft-coupon_info-up dft-coupon_info-up-large">{{ item.couponName }}</div>
                <div class="ellipsis-text dft-coupon_info-down dft-coupon_info-up-large">
                  {{ getCouponInfo(item.couponType,item) }}
                </div>
              </div>
            </div>
            <div class="typeitem" v-else-if="item.couponType == 2">
              <div class="dft-coupon_info-left" style="width: 50%">
                <div class="ellipsis-text price-sale-price" style="font-size: 25px">{{ item.discount }}折</div>
              </div>
              <div class="dft-coupon_info" :style="coupon_info_Style(item)">
                <div class="ellipsis-text dft-coupon_info-up dft-coupon_info-up-large">{{ item.couponName }}</div>
                <div class="ellipsis-text dft-coupon_info-down dft-coupon_info-up-large">
                  {{ getCouponInfo(item.couponType,item) }}
                </div>
              </div>
            </div>
            <div class="typeitem" v-else-if="item.couponType == 3">
              <div class="dft-coupon_info-left">
                <div class="price-tag" >¥</div>
                <div class="ellipsis-text price-sale-price">{{ item.reduceAmount }}</div>
              </div>
              <div class="dft-coupon_info" :style="coupon_info_Style(item)">
                <div class="ellipsis-text dft-coupon_info-up dft-coupon_info-up-large">{{ item.couponName }}</div>
                <div class="ellipsis-text dft-coupon_info-down dft-coupon_info-up-large">
                  {{ getCouponInfo(item.couponType,item) }}
                </div>
              </div>
            </div>
          </div>
          <div class="dft-press_area" v-if="show_coupon_btn" :style="press_area_style(item.isUse)">
            领取
          </div>
          <span v-if="['0'].includes(couponClass)" class="dft-coupon_dot_0_r"></span>
          <span v-if="['1','2'].includes(couponClass)" class="dft-coupon_bg-r" :style="coupon_bg_l_Style(item.isUse)"></span>
          <span v-if="[0].includes(listClass)&&['1'].includes(couponClass)" class="dft-coupon_dot dft-coupon_dot-1"></span>
          <span v-if="[0].includes(listClass)&&['1'].includes(couponClass)" class="dft-coupon_dot dft-coupon_dot-2"></span>
          <span v-if="['3'].includes(couponClass)" class="dft-coupon_dot_2"></span>
          <span v-if="['5'].includes(couponClass)" class="dft-coupon_border" :style="{borderColor:get5bordercolor()}"></span>
        </div>

        <div v-else-if="['6'].includes(couponClass)" class="dft-coupon_description dft-coupon_description6" :style="coupon_description_Style(item)">
          <div class="dft-coupon_left" :style="coupon_left_Style(item)">
            <div class="dft-coupon_type" :style="coupon_type_Style(item)">
              {{ getCouponType(item.couponType) }}
              <span class="dft-coupon_unit-sp"></span>
              <span class="dft-coupon_class6" :class="[2,3].includes(listClass)?'dft-coupon_class6-1s':'dft-coupon_class6-1'" :style="{backgroundColor: gettextcolor()}"></span>
              <span class="dft-coupon_class6" :class="[2,3].includes(listClass)?'dft-coupon_class6-2s':'dft-coupon_class6-2'" :style="{borderColor: gettextcolor()}"></span>
            </div>
            <div class="dft-coupon_info" :style="coupon_info_Style(item)">
              <span class="dft-coupon_class6 " :class="[2,3].includes(listClass)?'dft-coupon_class6-3s':'dft-coupon_class6-3'" :style="{backgroundColor: gettextcolor()}"></span>
              <div class="dft-coupon_info-up">{{ item.couponName }}</div>
              <div class="dft-coupon_info-down">
                {{ item.couponName }}
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="['7'].includes(couponClass)" class="dft-coupon_description dft-coupon_description7" :style="coupon_description_Style(item)">
          <div class="dft-coupon_left" :style="coupon_left_Style(item)">
            <div class="dft-coupon_info" :style="coupon_info_Style(item)">
              <div class="dft-coupon_info-up">{{ getCouponType(item.couponType) }}</div>
              <div class="dft-coupon_info-down">
                {{ item.couponName }}
              </div>
            </div>
          </div>
          <div class="dft-press_area" v-if="show_coupon_btn" :style="press_area_style(item.isUse)">
            <el-image v-if="[0,1].includes(listClass)" class="pick-img" :src="pickimg(item.isUse)" fit="cover"></el-image>
            <div v-else class="dft-coupon_press" :style="{backgroundColor: gettextcolor()}">
              领取
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showDialog: false,
      graybg1: require('@/assets/images/icon_img/couponclass1lc0.png'),
      graybg2c: require('@/assets/images/icon_img/couponclass2cc0.png'),
      graybg2l: require('@/assets/images/icon_img/couponclass2lc0.png'),
      graybg7r: require('@/assets/images/icon_img/couponclass7rc0.png'),
      gettedticket: require('@/assets/images/icon_img/gettedticket.png'),
      gettedticket1: require('@/assets/images/icon_img/gettedticket1.png'),
      gettedticket2: require('@/assets/images/icon_img/gettedticket2.png'),
      gettedticket3: require('@/assets/images/icon_img/gettedticket3.png'),
      test: require('@/assets/images/icon_img/couponclass1lc1.png'),
      couponList: []
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('comp--D-ata==--??',newVal)
          })
        }
      },
      deep: true
    }
  },
  computed: {
    // 数据
    // couponList() {
    //   return this.compData[0]?.value
    // },
    listClass () {
      return this.compData[1]?.value
    },
    couponClass () {
      return this.compData[2]?.value
    },
    couponBg () {
      return this.compData[3]?.value
    },
    show_coupon_btn () { // 是否显示领取
      switch (this.listClass) {
        case 0:
          return !['6'].includes(this.couponClass)
        case 1:
          return !['0', '1', '2', '3', '4', '6'].includes(this.couponClass)
        case 2:
          return !['0', '1', '2', '3', '4', '6', '8'].includes(this.couponClass)
        case 3:
          return !['0', '1', '2', '3', '4', '6', '8'].includes(this.couponClass)
        default:
          return {
          }
      }
    },
    // 样式
    container_Style () {
      return {
        [this.compData[2]?.key]: this.compData[2]?.value,
        [this.compData[9]?.key]: this.compData[9]?.value,
        [this.compData[10]?.key]: this.compData[10]?.value == '1' ? '1px solid #e7e7e7' : 'none',
        // 'background-color': this.couponClass=='1'||this.couponClass=='3'?'#ffffff':'transparent',
        'background-color': 'transparent'
      }
    },
    list_Style () { // 列表
      switch (this.listClass) {
        case 0:
          return {
            'flex-direction': 'column',
            'padding': `0 5px`
            // 'background-color': this.couponClass=='4'?'transparent':'#ffffff',
          }
        case 1:
          return {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0 5px`
            // 'background-color': this.couponClass=='4'?'transparent':'#ffffff',
          }
        case 2:
          return {
            'flex-wrap': 'wrap',
            'padding': `0 5px`
            // 'background-color': this.couponClass=='4'?'transparent':'#ffffff',
          }
        case 3:
          return {
            'flex-wrap': 'nowrap',
            'overflow-x': 'auto',
            'padding': `0 5px`
            // 'background-color': this.couponClass=='4'?'transparent':'#ffffff',
          }
        default:
          return {
          }
      }
    },
    list_item_Style () { // 每一项
      return isUse => {
        let extendC = {}
        switch (this.listClass) {
          case 0:
            switch (this.couponClass) {
              case '7':
                extendC = {
                  // 'background-color': '#fff',
                }
                break
              default:
                extendC = {}
            }
            return {
              'width': '100%',
              'color': isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
              // 'box-shadow': this.couponClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              // 'border': this.couponClass=='3'?'1px solid #ebedf0':'none',
              ...extendC
            }
          case 1:
            switch (this.couponClass) {
              case '6':
                extendC = {

                }
                break
              case '7':
                extendC = {
                  // 'background-color': '#fff',
                }
                break
              default:
                extendC = {}
            }
            return {
              'width': 'calc(100% - 10px)',
              'margin': '0 5px',
              'padding': '0',
              'color': isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
              // 'box-shadow': this.couponClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              ...extendC
            }
          case 2:
            switch (this.couponClass) {
              case '6':
                extendC = {
                }
                break
              case '7':
                extendC = {
                  // 'background-color': '#fff',
                }
                break
              default:
                extendC = {}
            }
            return {
              'width': 'calc((100% - 30px) / 3)',
              'margin': '0 5px',
              'padding': '0',
              'color': isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
              // 'box-shadow': this.couponClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              // 'border': this.couponClass=='3'?'1px solid #ebedf0':'none',
              ...extendC
            }
          case 3:
            switch (this.couponClass) {
              case '6':
                extendC = {
                }
                break
              case '7':
                extendC = {
                  // 'background-color': '#fff',
                }
                break
              default:
                extendC = {}
            }
            return {
              'width': '40%',
              'margin': '0 5px',
              'padding': '0',
              'flex-shrink': '0',
              'color': isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
              // 'box-shadow': this.couponClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              // 'border': this.couponClass=='3'?'1px solid #ebedf0':'none',
              ...extendC
            }
          default:
            return {
            }
        }
      }
    },

    coupon_description_Style () { // 商品信息
      return item => {
        let extendC = {}
        switch (this.listClass) {
          case 0:
            switch (this.couponClass) {
              case '7':
                extendC = {
                  'overflow': 'hidden',
                  'background-color': '#fff'
                }
                break
              default:
                extendC = {}
            }
            return {
              'box-shadow': this.couponBg == '#ffffff' ? '0 0 8px rgba(0, 0, 0, .1)' : 'unset',
              'background-color': ['1', '2', '6', '7', '8'].includes(this.couponClass) ? 'transparent' : item.isUse == 0 ? '#c8c9cc' : this.couponClass == '5' ? this.get5bg() : this.couponBg,
              'padding': ['5', '6', '7', '8'].includes(this.couponClass) ? '0' : '5px',
              'border': this.couponClass == '5' ? '2px solid' : 'none',
              'border-color': this.couponClass == '5' ? item.isUse == 0 ? '#c8c9cc' : this.get5bordercolor() : 'none',
              'outline-color': ['7'].includes(this.couponClass) ? this.getlefttextcolor() : 'unset',
              ...extendC
            }
          case 1:
            switch (this.couponClass) {
              case '7':
                extendC = {
                  'overflow': 'hidden',
                  'background-color': '#fff'
                }
                break
              default:
                extendC = {}
            }
            return {
              'box-shadow': this.couponBg == '#ffffff' ? '0 0 8px rgba(0, 0, 0, .1)' : 'unset',
              'background-color': ['1', '2', '6', '7', '8'].includes(this.couponClass) ? 'transparent' : item.isUse == 0 ? '#c8c9cc' : this.couponClass == '5' ? this.get5bg() : this.couponBg,
              'padding': ['5', '6', '7', '8'].includes(this.couponClass) ? '0' : '5px',
              'border': this.couponClass == '5' ? '2px solid' : 'none',
              'border-color': this.couponClass == '5' ? item.isUse == 0 ? '#c8c9cc' : this.get5bordercolor() : 'none',
              'outline-color': ['7'].includes(this.couponClass) ? this.getlefttextcolor() : 'unset',
              // 'margin': ['8'].includes(this.couponClass)?'0':'5px 0 5px',
              ...extendC
            }
          case 2:
            switch (this.couponClass) {
              case '5':
                extendC = {
                  'height': 'auto',
                  'flex-direction': 'column'
                }
                break
              case '6':
                extendC = {
                  'height': 'auto'
                }
                break
              case '7':
                extendC = {
                  'height': 'auto',
                  'flex-direction': 'column',
                  'overflow': 'hidden',
                  'background-color': '#fff'
                }
                break
              default:
                extendC = {}
            }
            return {
              'box-shadow': this.couponBg == '#ffffff' ? '0 0 8px rgba(0, 0, 0, .1)' : 'unset',
              'background-color': ['1', '2', '6', '7', '8'].includes(this.couponClass) ? 'transparent' : item.isUse == 0 ? '#c8c9cc' : this.couponClass == '5' ? this.get5bg() : this.couponBg,
              'padding': ['5', '6', '7', '8'].includes(this.couponClass) ? '0' : '5px',
              'border': this.couponClass == '5' ? '2px solid' : 'none',
              'border-color': this.couponClass == '5' ? item.isUse == 0 ? '#c8c9cc' : this.get5bordercolor() : 'none',
              'outline-color': ['7'].includes(this.couponClass) ? this.getlefttextcolor() : 'unset',
              // 'margin': ['8'].includes(this.couponClass)?'0':'5px 0 5px',
              ...extendC
            }
          case 3:
            switch (this.couponClass) {
              case '0':
                extendC = {
                  'height': '60px',
                  'background-image': this.getbg(), // "url('https://stjnfile.duochicai.com/resources/upload/dcc/homebg.png')",
                  'background-size': '100% 100%',
                  'background-repeat': 'no-repeat'
                }
                break
              case '5':
                extendC = {
                  'height': 'auto',
                  'flex-direction': 'column'
                }
                break
              case '6':
                extendC = {
                  'height': 'auto'
                }
                break
              case '7':
                extendC = {
                  'height': 'auto',
                  'flex-direction': 'column',
                  'overflow': 'hidden',
                  'background-color': '#fff'
                }
                break
              default:
                extendC = {}
            }
            return {
              'box-shadow': this.couponBg == '#ffffff' ? '0 0 8px rgba(0, 0, 0, .1)' : 'unset',
              'background-color': ['0', '1', '2', '6', '7', '8'].includes(this.couponClass) ? 'transparent' : item.isUse == 0 ? '#c8c9cc' : this.couponClass == '5' ? this.get5bg() : this.couponBg,
              'padding': ['5', '6', '7', '8'].includes(this.couponClass) ? '0' : '5px',
              'border': this.couponClass == '5' ? '2px solid' : 'none',
              'border-color': this.couponClass == '5' ? item.isUse == 0 ? '#c8c9cc' : this.get5bordercolor() : 'none',
              'outline-color': ['7'].includes(this.couponClass) ? this.getlefttextcolor() : 'unset',
              // 'margin': ['8'].includes(this.couponClass)?'0':'5px 0 5px',
              ...extendC
            }
          default:
            return {
            }
        }
      }
    },
    coupon_bg_Style () { // 背景色
      return isUse => {
        switch (this.couponClass) {
          case '1':
            return {
              'width': 'calc(100% - 20px)',
              'left': '11px',
              'background-color': isUse == 0 ? '#d3d6d9' : this.couponBg
            }
          case '2':
            return {
              'width': 'calc(100% - 36px)',
              'left': '18px',
              'background-image': isUse == 0 ? `url(${this.graybg2c})` : this.getmidimg()
            }
          case '0':
          case '3':
          case '4':
            return {
              // 'background-color': this.couponBg,
            }
          default:
            return {
            }
        }
      }
    },
    coupon_bg_l_Style () { // 背景色
      return isUse => {
        switch (this.couponBg) {
          case '#e74c2c':
            return {
              'width': this.couponClass == '1' ? '11px' : '18px',
              // 'background-image': `url(${this.test})`,
              'background-image': isUse == 0 ? `url(${this.couponClass == '1' ? this.graybg1 : this.graybg2l})`
                : this.couponClass == '1' ? `url(${require('@/assets/images/icon_img/couponclass1lc1.png')})` : `url(${require('@/assets/images/icon_img/couponclass2lc1.png')})`
            }
          case '#ffe9b7':
            return {
              'width': this.couponClass == '1' ? '11px' : '18px',
              'background-image': isUse == 0 ? `url(${this.couponClass == '1' ? this.graybg1 : this.graybg2l})`
                : this.couponClass == '1' ? `url(${require('@/assets/images/icon_img/couponclass1lc2.png')})` : `url(${require('@/assets/images/icon_img/couponclass2lc2.png')})`
            }
          case '#ffffff':
            return {
              'width': this.couponClass == '1' ? '11px' : '18px',
              'background-image': isUse == 0 ? `url(${this.couponClass == '1' ? this.graybg1 : this.graybg2l})`
                : this.couponClass == '1' ? `url(${require('@/assets/images/icon_img/couponclass1lc3.png')})` : `url(${require('@/assets/images/icon_img/couponclass2lc3.png')})`
            }
          case '#383b3e':
            return {
              'width': this.couponClass == '1' ? '11px' : '18px',
              'background-image': isUse == 0 ? `url(${this.couponClass == '1' ? this.graybg1 : this.graybg2l})`
                : this.couponClass == '1' ? `url(${require('@/assets/images/icon_img/couponclass1lc4.png')})` : `url(${require('@/assets/images/icon_img/couponclass2lc4.png')})`
            }
          case '#e0f4e4':
            return {
              'width': this.couponClass == '1' ? '11px' : '18px',
              'background-image': isUse == 0 ? `url(${this.couponClass == '1' ? this.graybg1 : this.graybg2l})`
                : this.couponClass == '1' ? `url(${require('@/assets/images/icon_img/couponclass1lc5.png')})` : `url(${require('@/assets/images/icon_img/couponclass2lc5.png')})`
            }
          default:
            return {
              'width': this.couponClass == '1' ? '11px' : '18px',
              'background-image': isUse == 0 ? `url(${this.couponClass == '1' ? this.graybg1 : this.graybg2l})` : this.couponBg
            }
        }
      }
    },
    coupon_left_Style () { // 商品名
      return item => {
        switch (this.listClass) {
          case 0:
            switch (this.couponClass) {
              case '1':
                return {}
              case '2':
                return {}
              case '3':
                return {
                  'background': '#fff',
                  'color': this.getlefttextcolor()
                }
              case '8':
                return {
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.couponBg,
                  'border-radius': '7px'
                }
              default:
                return {}
            }
          case 1:
            switch (this.couponClass) {
              case '1':
                return {}
              case '2':
                return {}
              case '3':
                return {
                  'background': '#fff',
                  'color': this.getlefttextcolor(),
                  'margin-right': '30px'
                }
              case '6':
                return {
                  'flex-direction': 'column'
                }
              case '7':
                return {
                  'margin-right': '30px'
                }
              case '8':
                return {
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.couponBg,
                  'border-radius': '7px'
                }
              default:
                return {}
            }
          case 2:
            switch (this.couponClass) {
              case '1':
                return {}
              case '2':
                return {}
              case '3':
                return {
                  'background': '#fff',
                  'color': this.getlefttextcolor(),
                  'margin-right': '10px'
                }
              case '5':
                return {
                  'height': '80px',
                  'flex': 'unset'
                }
              case '6':
                return {
                  'flex-direction': 'column'
                }
              case '7':
                return {
                  'height': '80px',
                  'flex': 'unset'
                }
              case '8':
                return {
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.couponBg,
                  'border-radius': '7px'
                }
              default:
                return {}
            }
          case 3:
            switch (this.couponClass) {
              case '1':
                return {}
              case '2':
                return {}
              case '3':
                return {
                  'background': '#fff',
                  'color': this.getlefttextcolor(),
                  'margin-right': '10px'
                }
              case '5':
                return {
                  'height': '80px',
                  'flex': 'unset'
                }
              case '6':
                return {
                  'flex-direction': 'column'
                }
              case '7':
                return {
                  'height': '80px',
                  'flex': 'unset'
                }
              case '8':
                return {
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.couponBg,
                  'border-radius': '7px'
                }
              default:
                return {}
            }
          default:
            return {
            }
        }
      }
    },
    coupon_type_Style () { // 商品名
      return item => {
        switch (this.listClass) {
          case 0:
            switch (this.couponClass) {
              case '6':
                return {
                  'color': item.isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
                  'background': item.isUse == 0 ? 'linear-gradient(90deg, #dadddf 2%, #a7a7a7 96%);' : this.get6bg(),
                  'border-radius': '7px 0 0 7px'
                }
              default:
                return {
                  '-webkit-line-clamp': '1'
                }
            }
          case 1:
            switch (this.couponClass) {
              case '6':
                return {
                  'width': '90%',
                  'height': '54px',
                  'color': item.isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
                  'background': item.isUse == 0 ? 'linear-gradient(90deg, #dadddf 2%, #a7a7a7 96%);' : this.get6bg(),
                  'border-radius': '7px 7px 0 0'
                }
              default:
                return {
                  '-webkit-line-clamp': '1'
                }
            }
          case 2:
            switch (this.couponClass) {
              case '6':
                return {
                  'width': '90%',
                  'height': '54px',
                  'color': item.isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
                  'background': item.isUse == 0 ? 'linear-gradient(90deg, #dadddf 2%, #a7a7a7 96%);' : this.get6bg(),
                  'border-radius': '7px 7px 0 0'
                }
              default:
                return {
                  '-webkit-line-clamp': '1'
                }
            }
          case 3:
            switch (this.couponClass) {
              case '6':
                return {
                  'width': '90%',
                  'height': '54px',
                  'color': item.isUse == 0 ? '#d3d6d9' : this.gettextcolor(),
                  'background': item.isUse == 0 ? 'linear-gradient(90deg, #dadddf 2%, #a7a7a7 96%);' : this.get6bg(),
                  'border-radius': '7px 7px 0 0'
                }
              default:
                return {
                  '-webkit-line-clamp': '2'
                }
            }
          default:
            return {
            }
        }
      }
    },
    coupon_info_Style () { // 优惠券描述
      return item => {
        switch (this.listClass) {
          case 0:
            switch (this.couponClass) {
              case '6':
                return {
                  'color': '#fff',
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.gettextcolor(),
                  'border-radius': '0 7px 7px 0'
                }
              default:
                return {
                  'text-align': 'center'
                }
            }
          case 1:
            switch (this.couponClass) {
              case '6':
                return {
                  'width': '100%',
                  'height': '74px',
                  'flex': 'unset',
                  'color': '#fff',
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.gettextcolor(),
                  'border-radius': '0 0 7px 7px'
                }
              default:
                return {
                  'text-align': 'center',
                  'margin-left': '0'
                }
            }
          case 2:
            switch (this.couponClass) {
              case '6':
                return {
                  'width': '100%',
                  'height': '74px',
                  'flex': 'unset',
                  'color': '#fff',
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.gettextcolor(),
                  'border-radius': '0 0 7px 7px'
                }
              default:
                return {
                  'text-align': 'center',
                  'margin-left': '0'
                }
            }
          case 3:
            switch (this.couponClass) {
              case '6':
                return {
                  'width': '100%',
                  'height': '74px',
                  'flex': 'unset',
                  'color': '#fff',
                  'background-color': item.isUse == 0 ? '#c8c9cc' : this.gettextcolor(),
                  'border-radius': '0 0 7px 7px'
                }
              default:
                return {
                  'text-align': 'center',
                  'margin-left': '0'

                }
            }
          default:
            return {
            }
        }
      }
    },
    press_area_style () { // 按压区域
      return isUse => {
        switch (this.couponClass) {
          case '1':
            return {
              'border-left': '1px dashed',
              'border-color': isUse == 0 ? '#fff' : this.getborderColor()
            }
          case '5':
            switch (this.listClass) {
              case 1:
                return {
                  'border-left': '1px dashed',
                  'border-color': isUse == 0 ? '#fff' : this.getborderColor(),
                  'height': '54px',
                  'width': '30px',
                  'padding-right': '5px',
                  'writing-mode': 'vertical-rl'
                }
              case 2:
              case 3:
                return {
                  'border-top': '1px dashed',
                  'border-color': isUse == 0 ? '#fff' : this.getborderColor(),
                  'height': '24px',
                  'width': '60%',
                  'padding-bottom': '5px'
                }
              default:
                return {
                  'border-left': '1px dashed',
                  'border-color': isUse == 0 ? '#fff' : this.getborderColor(),
                  'height': '54px'
                }
            }
          case '7':
            switch (this.listClass) {
              case 1:
                return {
                  'position': 'absolute',
                  'top': '0',
                  'right': '-80px'
                }
              case 2:
              case 3:
                return {
                  'width': '100%',
                  'height': '50px',
                  'padding': '0 8px 16px',
                  'box-sizing': 'border-box'
                }
              default:
                return {}
            }
          case '2':
            return {
              // 'background-image': isUse == 0?`url(${this.graybg2c})`:this.getmidimg(),
            }
          case '0':
          case '3':
          case '4':
            return {
              // 'background-color': this.couponBg,
            }
          case '8':
            switch (this.listClass) {
              case 1:
                return {
                  'height': '100%',
                  'background-color': isUse == 0 ? '#c8c9cc' : this.couponBg,
                  'border-radius': '7px',
                  'margin-left': '1px',
                  'width': '30px',
                  'writing-mode': 'vertical-rl'
                }
              default:
                return {
                  'height': '100%',
                  'background-color': isUse == 0 ? '#c8c9cc' : this.couponBg,
                  'border-radius': '7px',
                  'margin-left': '1px'
                }
            }
          default:
            return {
            }
        }
      }
    },
    pickimg () { // 7-右侧领取
      return isUse => {
        switch (this.couponBg) {
          case '#e74c2c':
            return isUse == 0 ? `${this.graybg7r}` : `${require('@/assets/images/icon_img/couponclass7rc1.png')}`
          case '#ffe9b7':
            return isUse == 0 ? `${this.graybg7r}` : `${require('@/assets/images/icon_img/couponclass7rc2.png')}`
          case '#ffffff':
            return isUse == 0 ? `${this.graybg7r}` : `${require('@/assets/images/icon_img/couponclass7rc1.png')}`
          case '#383b3e':
            return isUse == 0 ? `${this.graybg7r}` : `${require('@/assets/images/icon_img/couponclass7rc4.png')}`
          case '#e0f4e4':
            return isUse == 0 ? `${this.graybg7r}` : `${require('@/assets/images/icon_img/couponclass7rc5.png')}`
          default:
            return isUse == 0 ? `${this.graybg7r}` : `${require('@/assets/images/icon_img/couponclass7rc1.png')}`
        }
      }
    }
  },
  created () {
    this.getCouponList()
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    getCouponList () {
      var that = this
      const _queryInfo = {
        condition: {
          userType: 3,
          surplusNumType: 1// 剩余数量大于0
        },
        currPage: 1,
        pageSize: 3
      }
      that.$http.post('/coupon/list', _queryInfo).then(res => {
        if (res.data.code == 200) {
          that.couponList = res.data.data.data
        }
      })
    },
    // 优惠券类型
    getCouponType (val) {
      return val == 1 ? '代金券' : val == 2 ? '折扣券' : val == 3 ? '满减券' : ''
    },
    // 优惠券说明
    getCouponInfo (val, item) {
      // return val == 1?'代金券':val == 2?'折扣券':val == 3?'满减券':''
      switch (val) {
        case 1:
          return '满0.01元可用'
        case 2:
          let _info = '满0.01元可用'
          if (item.isLimit == 1) {
            _info = `满${item.customeAmount}元可用`
          }
          return _info
        case 3:
          return `满${item.fullAmount}元可用`

        default:
          break
      }
    },
    gettextcolor () {
      switch (this.couponBg) {
        case '#e74c2c':
          return ['5', '6', '7'].includes(this.couponClass) ? '#e74c2c' : '#fff'
        case '#ffe9b7':
          return '#f39343'
        case '#ffffff':
          return ['0', '5', '6', '7'].includes(this.couponClass) ? '#e74c2c' : '#383b3e'
        case '#383b3e':
          return ['5', '6', '7'].includes(this.couponClass) ? '#383b3e' : '#fff'
        case '#e0f4e4':
          return '#4cac5a'
        default:
          return ''
      }
    },
    getlefttextcolor () {
      switch (this.couponBg) {
        case '#e74c2c':
          return '#e74c2c'
        case '#ffe9b7':
          return '#f39343'
        case '#ffffff':
          return '#383b3e'
        case '#383b3e':
          return '#383b3e'
        case '#e0f4e4':
          return '#4cac5a'
        default:
          return ''
      }
    },
    getborderColor () {
      switch (this.couponBg) {
        case '#e74c2c':
          return this.couponClass == '5' ? 'red' : '#ffffff80'
        case '#ffe9b7':
          return 'rgba(243,147,67,.5)'
        case '#ffffff':
          return '#9999994d'
        case '#383b3e':
          return '#99999980'
        case '#e0f4e4':
          return 'rgba(99,190,114,.5)'
        default:
          return ''
      }
    },
    get5bg () {
      switch (this.couponBg) {
        case '#e74c2c':
          return '#fdf1ed'
        case '#ffe9b7':
          return '#fcf5e5'
        case '#ffffff':
          return '#fff'
        case '#383b3e':
          return '#f2f3f3'
        case '#e0f4e4':
          return '#f1f8f3'
        default:
          return ''
      }
    },
    get5bordercolor () {
      switch (this.couponBg) {
        case '#e74c2c':
          return '#ec6e55'
        case '#ffe9b7':
          return '#f39343'
        case '#ffffff':
          return '#969799'
        case '#383b3e':
          return '#383b3e'
        case '#e0f4e4':
          return '#63b270'
        default:
          return ''
      }
    },

    get6bg () {
      switch (this.couponBg) {
        case '#e74c2c':
          return 'linear-gradient(90deg, #fff2ee 2%, #ffd3cb 99%)'
        case '#ffe9b7':
          return 'linear-gradient(90deg, #fff6dc, #fdd886)'
        case '#ffffff':
          return 'linear-gradient(90deg, #fff, #d1d2d2)'
        case '#383b3e':
          return 'linear-gradient(90deg, #fff, #d1d2d2)'
        case '#e0f4e4':
          return 'linear-gradient(90deg, #fff, #eaffed)'
        default:
          return ''
      }
    },
    getmidimg () {
      switch (this.couponBg) {
        case '#e74c2c':
          return `url(${require('@/assets/images/icon_img/couponclass2cc1.png')})`
        case '#ffe9b7':
          return `url(${require('@/assets/images/icon_img/couponclass2cc2.png')})`
        case '#ffffff':
          return `url(${require('@/assets/images/icon_img/couponclass2cc3.png')})`
        case '#383b3e':
          return `url(${require('@/assets/images/icon_img/couponclass2cc4.png')})`
        case '#e0f4e4':
          return `url(${require('@/assets/images/icon_img/couponclass2cc5.png')})`
        default:
          return ''
      }
    },
    getbg () {
      switch (this.couponBg) {
        case '#e74c2c':
          return `url('https://stjnfile.duochicai.com/resources/upload/dcc/ticketbg1.png')`
        case '#ffe9b7':
          return `url('https://stjnfile.duochicai.com/resources/upload/dcc/ticketbg2.png')`
        case '#ffffff':
          return `url('https://stjnfile.duochicai.com/resources/upload/dcc/ticketbg3.png')`
        case '#383b3e':
          return `url('https://stjnfile.duochicai.com/resources/upload/dcc/ticketbg4.png')`
        case '#e0f4e4':
          return `url('https://stjnfile.duochicai.com/resources/upload/dcc/ticketbg5.png')`
        default:
          return ''
      }
    },
    getLitemStyle (index) {
      this.$nextTick(() => {
        const el = this.$refs['dftItem' + index][0]
        const rows = Math.ceil(el.clientHeight / 5) + 0
        console.log('>J?', index, el, rows)
        el.style.gridRowEnd = `span ${rows}`
        el.style.margin = `${this.compData[16]?.value / 2}px`
        // el.style = {'grid-row-end': `span ${rows}`}
        // return {'grid-row-end': 'span ' + rows}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  box-sizing: border-box;
}
.dft-list{
  display: flex;
  padding: 5px 0;
  background-color: transparent;
  .dft-item{
    box-sizing: border-box;
    padding: 0 12px;
    .dft-coupon_img{
      position: relative;
      max-height: 500px;
      overflow: hidden;
    }
    .dft-coupon_description{
      border-radius: 8px;
      width: 100%;
      height: 64px;
      // padding: 5px;
      margin: 5px 0 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      box-sizing: border-box;
      background-color: transparent;
      // color: #333333;
      position: relative;
      .dft-coupon_bg-l{
        position: absolute;
        top: 0;
        left: 0;
        width: 11px;
        height: 100%;
        background-size: 100% 100%;
        content: "";
        z-index: 1;
      }
      .dft-coupon_bg{
        position: absolute;
        top: 0;
        height: 100%;
        background-repeat: repeat-x;
        background-size: 1px 100%;
        z-index: 1;
      }
      .dft-coupon_bg-r{
        position: absolute;
        top: 0;
        right: 0;
        width: 11px;
        height: 100%;
        background-size: 100% 100%;
        transform: rotateY(180deg);
        content: "";
        z-index: 1;
      }
      .dft-coupon_left,.typeitem{
        display: flex;
        flex: 1;
        height: 100%;
        align-items: center;
        font-weight: 700;
        z-index: 2;
      }
      .dft-coupon_type{
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        font-size: 20px;
        width: 38%;
        position: relative;
        .dft-coupon_unit-sp{
          display: table-cell;
          padding-left: 2px;
          font-size: 12px;
        }
      }
      .dft-coupon_info-left{
        width: 42%;
        display: flex;
        align-items: baseline;
        justify-content: center;
        .price-tag{
          font-weight: bold;
          margin-right: 2px;
          font-size: 14px;
          line-height: 14px;
        }
        .price-sale-price{
          font-family: Avenir;
          font-size: 30px;
          font-weight: bold;
          //width: 50px;
        }
      }
      .dft-coupon_info{
        position: relative;
        flex: 1;
        font-size: 12px;
        line-height: 16px;
        margin-top: 4px;
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-left: 13px;
        .dft-coupon_info-up{
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .dft-coupon_info-down{
          margin-top: 5px;
          font-size: 12px;
          line-height: 16px;
          opacity: .8;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .dft-coupon_info-up-large{
          font-size: 11px;
          line-height: 15px;
          font-weight: 400;
        }
      }
      .dft-press_area{
        position: relative;
        display: flex;
        width: 82px;
        height: 70px;
        justify-content: center;
        align-items: center;
        margin: 0;
        font-size: 14px;
        line-height: 14px;
        z-index: 2;
      }
      .dft-coupon_dot{
        position: absolute;
        right: 83px;
        display: flex;
        width: 10px;
        height: 10px;
        background-color: rgb(249, 249, 249);
        border-radius: 50%;
        content: "";
        z-index: 2;
      }
      .dft-coupon_dot-1{
        top: -5px;
      }
      .dft-coupon_dot-2{
        bottom: -5px;
      }
      .dft-coupon_dot_2{
        position: absolute;
        top: 50%;
        right: -7px;
        display: flex;
        width: 14px;
        height: 14px;
        margin-top: -7px;
        background-color: #fff;
        border-radius: 50%;
        content: "";
        z-index: 2;
      }
      .dft-coupon_border{
        position: absolute;
        top: 3px;
        left: 3px;
        box-sizing: border-box;
        width: calc(100% - 6px);
        height: calc(100% - 6px);
        margin: 0;
        border: 1px solid #969799;
        content: " ";
      }
    }
    .dft-coupon_description6{
      background: transparent;
      height: 96px;
      overflow: hidden;
      .dft-coupon_type{
        width: 30%;
        height: 88px;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        overflow: visible;
        z-index: 3;
        // margin: -5px 0;
      }
      .dft-coupon_info{
        height: 96px;
        text-align: center;
        align-items: center;
        justify-content: center;
        margin: 0;
      }
      .dft-coupon_info-up, .dft-coupon_info-down{
        z-index: 8;
      }
      .dft-coupon_class6{
        position: absolute;
      }
      .dft-coupon_class6-1{
        right: -19px;
        z-index: 3;
        width: 30px;
        height: 117%;
        background: #e74c2c;
        -webkit-transform: rotate(13deg);
        transform: rotate(13deg);
        content: " ";
      }
      .dft-coupon_class6-1s{
        bottom: -16px;
        width: 126%;
        height: 25px;
        background: #e74c2c;
        -webkit-transform: rotate(10deg);
        transform: rotate(10deg);
        content: " ";
      }
      .dft-coupon_class6-2{
        top: 4px;
        left: 4px;
        box-sizing: border-box;
        width: 100%;
        height: calc(100% - 8px);
        border: 1px solid #e74c2c;
        border-top-left-radius: 7px;
        border-bottom-left-radius: 7px;
        content: " ";
      }
      .dft-coupon_class6-2s{
        bottom: 0;
        width: calc(100% - 8px);
        height: 100%;
        border-radius: unset;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
        top: 4px;
        left: 4px;
        box-sizing: border-box;
        border: 1px solid #e74c2c;
        content: " ";
      }
      .dft-coupon_class6-3{
        left: -71px;
        width: 71px;
        height: 100%;
        background: #e74c2c;
        border-top-left-radius: 7px;
        border-bottom-left-radius: 7px;
        z-index: 1;
        content: " ";
      }
      .dft-coupon_class6-3s{
        top: -22px;
        left: 0;
        width: 100%;
        height: 22px;
        border-radius: unset;
        background: #e74c2c;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
        z-index: 1;
        content: " ";
      }
    }
    .dft-coupon_description7{
      outline: 1px solid;
      outline-offset: -5px;
      padding: 0;
      background: #fff;
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, .05);
      box-sizing: border-box;
      .dft-coupon_info{
        text-align: center;
      }
      .dft-press_area{
        width: 130px;
        height: 100%;
        overflow: visible;
        // right: -25px;
        // left: -15px;
      }
      .pick-img{
        height: 100%;
        width: 100%;
        overflow: visible;
      }
      .dft-coupon_press{
        width: 34px;
        height: 34px;
        color: #fff;
        font-size: 12px;
        line-height: 34px;
        text-align: center;
        border-radius: 50%;
      }
    }
  }
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.dft-coupon_dot_0_l{
  position: absolute;
  top: 50%;
  left: -7px;
  display: flex;
  border: 7px solid transparent;
  margin-top: -7px;
  border-radius: 50%;
  border-left-color: transparent;
  border-bottom-color: transparent;
  transform: rotate(45deg);
  content: "";
  z-index: 2;
}
.dft-coupon_dot_0_r{
  position: absolute;
  top: 50%;
  right: -7px;
  display: flex;
  border: 7px solid transparent;
  margin-top: -7px;
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
  transform: rotate(45deg);
  content: "";
  z-index: 2;
}
</style>
